<template>
    <div class="podcast">
        <div class="ancla2" id="podcast"></div>
        <div class="content">
            <!-- <iframe src="https://open.spotify.com/embed-podcast/show/0brUPXLlWMPg1KpnYZzRV0" width="100%" height="232" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe> -->
            <div class="contenido">
                <b-row>
                    <b-col cols="12" order="2" md="5" order-md="1">
                        <div class="contentDisponible">
                            <strong>Disponible en</strong>
                            <div class="disponible">
                                <a href="https://open.spotify.com/show/0brUPXLlWMPg1KpnYZzRV0?si=KnvRXbGfQOSmaPjImKfByA" target="_blank">
                                    <img class="spotify" src="../assets/img/icn_spotify.svg" alt="Spotify">
                                </a>
                                <a href="https://podcasts.apple.com/mx/podcast/hanniel-maldonado-estrategia-comercial/id1448106090?l=en" target="_blank">
                                    <img src="../assets/img/icn_apple.svg" alt="Apple">
                                </a>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" order="1" md="7" order-md="2">
                        <h3><span>Escucha mi podcast</span> Hanniel maldonado: estrategia comercial</h3>
                        <p>Los expertos en ventas somos ambiciosos y constantemente buscamos perfeccionar nuestro proceso de ventas. Vender no es un trabajo, es un estilo de vida. En este podcast encontrarás consejos y estrategias de ventas, para vivir las ventas como todo un experto.</p>
                        <div class="controls">  
                            <img src="../assets/img/icn_play.svg" alt="Play" @click.prevent="playSound">
                            <img src="../assets/img/icn_pause.svg" alt="Pause" @click.prevent="pauseSound">
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="contentSonido">
                <div class="sonido"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                audio: ''
                
            }
        },
        mounted(){
            this.audio = new Audio('./static/Promo-Audio.mp4')
        },
        methods: {
            playSound () {
                this.audio.play();
            },
            pauseSound (sound) {
                this.audio.pause();
            }
        }
    }
</script>

<style scoped>
    .podcast{
        position: relative;
    }
    .podcast *{
        color: white;
    }
    .contenido{
        background-image: url('../assets/img/img_podcast.jpg');
        background-size: cover;
        background-position: left center;
        padding: 60px 30px 20px 30px;
    }
    .contentSonido{
        background-color: #EC4802;
        height: 60px;
    }
    h3 span{
        color: #EC4802!important;
    }
    .sonido{
        background-image: url('../assets/img/icn_sound.svg');
        height: 60px;
        background-repeat: no-repeat;
        background-size: 90%;
        background-position: center;
    }
    .controls img{
        width: 50px;
        cursor: pointer;
    }
    .row{
        align-items: flex-end;
    }
    strong{
        display: block;
    }
    .disponible img{
        width: 25px;
        margin-top: 8px;
    }
    .disponible .spotify{
        margin-right: 5px;
    }

    @media screen and (max-width: 767px){
        .contenido{
            background-position-x: 20%;
             padding: 60px 15px 20px 15px;
        }
        .sonido{
            background-size: 200%;
        }
        .contentDisponible{
            margin-top: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Podcast.vue